import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'

const ModalConfirmacion = ({
  open,
  onClose,
  onClick,
  title = '¿Estás seguro?',
  content = 'Esta operación no puede deshacerse',
  okText = 'Confirmar',
  cancelText = 'Cancelar',
  hideCancel = false,
  maxWidth = 'sm'
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    transitionDuration={0}
    maxWidth={maxWidth}
    fullWidth
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{content}</DialogContentText>
    </DialogContent>
    <DialogActions>
      {!hideCancel && <Button onClick={onClose}>{cancelText}</Button>}
      <Button color='error' onClick={onClick || onClose}>
        {okText}
      </Button>
    </DialogActions>
  </Dialog>
)

export default ModalConfirmacion
